import { render } from "./loginPage.vue?vue&type=template&id=1442e33a&scoped=true"
import script from "./loginPage.vue?vue&type=script&lang=js"
export * from "./loginPage.vue?vue&type=script&lang=js"

import "./loginPage.vue?vue&type=style&index=0&id=1442e33a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1442e33a"]])

export default __exports__